"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("ui-addon-upgrades/utils");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _UIScrollContainer = _interopRequireDefault(require("UIComponents/scroll/UIScrollContainer"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _colors = require("HubStyleTokens/colors");

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _FeaturesMap = _interopRequireDefault(require("self-service-api/constants/FeaturesMap"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _ProductCatalogTableCell = _interopRequireDefault(require("ui-addon-upgrades/_core/productCatalog/ProductCatalogTableCell"));

var _ProductCatalogTableRow = _interopRequireDefault(require("ui-addon-upgrades/_core/productCatalog/ProductCatalogTableRow"));

var _ProductPageIcons = _interopRequireDefault(require("ui-addon-upgrades/_core/productPage/ProductPageIcons"));

var _FooterMicrocopy = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/FooterMicrocopy"));

var _responsiveBreakpoints = _interopRequireDefault(require("ui-addon-upgrades/_core/utils/responsiveBreakpoints"));

var _utils2 = require("../../utils");

var _partial = _interopRequireDefault(require("react-utils/partial"));

var PurchaseTypes = _interopRequireWildcard(require("self-service-api/constants/PurchaseTypes"));

var _HubSpecificFreeFeaturesMap = _interopRequireDefault(require("self-service-api/constants/HubSpecificFreeFeaturesMap"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n    padding: 1rem 0;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: flex;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MODAL_WIDTH = 1200;
var HEADER_HEIGHT = 128;
var MODAL_TOP_MARGIN = 60;
var MODAL_BOTTOM_MARGIN = 47;

var HeaderSection = _styledComponents.default.div.withConfig({
  displayName: "ProductCatalogModal__HeaderSection",
  componentId: "sc-2ubqzz-0"
})(["box-shadow:0 2px 4px 0 rgba(37,37,37,0.2);z-index:100;"]);

var ModalHeader = _styledComponents.default.div.withConfig({
  displayName: "ProductCatalogModal__ModalHeader",
  componentId: "sc-2ubqzz-1"
})(["text-align:center;background-color:", ";padding:20px 0;& > h3{margin:0;}img{height:20px;}"], _colors.GYPSUM);

var TopHeaderCell = _styledComponents.default.th.withConfig({
  displayName: "ProductCatalogModal__TopHeaderCell",
  componentId: "sc-2ubqzz-2"
})(["padding:20px;background-color:", ";height:50px;text-align:center;width:18.75%;min-width:175px;& > h6{margin:0;}:first-child{padding:0;width:2%;min-width:30px;}:nth-child(2){padding-left:0;width:25%;text-align:left;}"], _colors.OLAF);

var Table = _styledComponents.default.table.withConfig({
  displayName: "ProductCatalogModal__Table",
  componentId: "sc-2ubqzz-3"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);

var TierSelector = _styledComponents.default.div.withConfig({
  displayName: "ProductCatalogModal__TierSelector",
  componentId: "sc-2ubqzz-4"
})(["display:none;width:90%;margin:0 auto;padding:2rem 0;text-align:center;button{font-size:0.75rem;cursor:pointer;padding:calc(1rem + 1px) 2rem;background:#fff;border:1px solid #7fd1de;flex-basis:25%;margin-right:-1px;text-align:center;transition:background-color 0.3s;&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}}button:first-child{border-radius:3px 0 0 3px;}button:last-child{border-radius:0 3px 3px 0;margin-right:0;}ul{display:none;list-style:none;padding:0;width:60%;margin:0 auto;text-align:left;li{font-size:16px;cursor:pointer;color:#0091ae;}}#tierToggle{position:absolute;top:-9999px;left:-9999px;}input[type='checkbox']:checked ~ label ~ ul{display:block;}", ";", ";"], _responsiveBreakpoints.default.tabletPortrait(_templateObject()), _responsiveBreakpoints.default.phone(_templateObject2()));

var TierSelected = _styledComponents.default.label.withConfig({
  displayName: "ProductCatalogModal__TierSelected",
  componentId: "sc-2ubqzz-5"
})(["color:#0091ae;font-size:18px;font-weight:600;margin-right:3px;cursor:pointer;"]);

var ProductCatalogModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ProductCatalogModal, _React$Component);

  function ProductCatalogModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductCatalogModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProductCatalogModal).call(this));

    _this.handleTierSelect = function (keyToSet) {
      _this.setState({
        activeColumn: keyToSet
      });
    };

    _this.handleWindowSizeChange = function () {
      _this.setState({
        width: window.innerWidth
      });
    };

    _this.state = {
      width: window.innerWidth,
      activeColumn: 0
    };
    return _this;
  }

  (0, _createClass2.default)(ProductCatalogModal, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      var resizeWindow = (0, _utils2.debounce)(function () {
        _this2.handleWindowSizeChange();
      }, 250);
      window.addEventListener('resize', resizeWindow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: "renderTableRows",
    value: function renderTableRows() {
      var hub = this.props.hub;
      var highlightedFreeMerch = _HubMap.default[hub].highlightedFreeMerch;
      var orderedMerchIdsForHub = [].concat((0, _toConsumableArray2.default)(highlightedFreeMerch ? [highlightedFreeMerch] : []), (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch));

      var highestTierFeatures = _ImmutableMerchandiseIdMap.default[(0, _utils.last)(orderedMerchIdsForHub)].features;

      var enterpriseFeatureIds = Object.keys(highestTierFeatures);
      return enterpriseFeatureIds.map(function (featureId) {
        return _react.default.createElement(_ProductCatalogTableRow.default, {
          featureId: featureId,
          key: featureId,
          hub: hub,
          freeUserAccess: _FeaturesMap.default[featureId] && _HubMap.default[hub].merchPurchaseType === PurchaseTypes.SEAT_BASED && _FeaturesMap.default[featureId].freeUser
        }, orderedMerchIdsForHub.map(function (merchId) {
          var features;

          if (merchId === MerchandiseIds.PRODUCT_CRM) {
            features = _HubSpecificFreeFeaturesMap.default[hub] || {};
          } else {
            features = _ImmutableMerchandiseIdMap.default[merchId].features;
          }

          return _react.default.createElement(_ProductCatalogTableCell.default, {
            feature: features[featureId],
            key: merchId
          });
        }));
      });
    }
  }, {
    key: "renderMobileTableRows",
    value: function renderMobileTableRows() {
      var hub = this.props.hub;
      var activeColumn = this.state.activeColumn;
      var highlightedFreeMerch = _HubMap.default[hub].highlightedFreeMerch;
      var orderedMerchIdsForHub = [].concat((0, _toConsumableArray2.default)(highlightedFreeMerch ? [highlightedFreeMerch] : []), (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch));
      var currentFeatureIds = Object.keys(_ImmutableMerchandiseIdMap.default[orderedMerchIdsForHub[activeColumn]].features);
      return currentFeatureIds.map(function (featureId, i) {
        // TODO Hiding the tooltips on mobile for now since they jump off the screen.
        //  Will probably need a different solution to better present the extra info on mobile
        return _react.default.createElement(_ProductCatalogTableRow.default, {
          featureId: featureId,
          key: i,
          hub: hub,
          freeUserAccess: _FeaturesMap.default[featureId] && _HubMap.default[hub].merchPurchaseType === PurchaseTypes.SEAT_BASED && _FeaturesMap.default[featureId].freeUser,
          showTooltip: false
        }, orderedMerchIdsForHub.map(function (merchId, j) {
          if (j === activeColumn) {
            return _react.default.createElement(_ProductCatalogTableCell.default, {
              featureId: featureId,
              merchandiseId: merchId,
              colId: j,
              showTooltip: false,
              key: j
            });
          }

          return null;
        }));
      });
    }
  }, {
    key: "renderTableHeader",
    value: function renderTableHeader(headerKeys) {
      return _react.default.createElement(Table, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement(TopHeaderCell, null), headerKeys.map(function (headerKey, i) {
        return _react.default.createElement(TopHeaderCell, {
          "data-key": i - 1,
          key: i
        }, _react.default.createElement(_H2.default, null, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.productCatalog.tableHeader." + headerKey
        })));
      }))));
    }
  }, {
    key: "renderMobileTableHeader",
    value: function renderMobileTableHeader(headerKeys) {
      var _this3 = this;

      return _react.default.createElement(Table, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, headerKeys.map(function (headerKey, i) {
        if (i === 0 || i - 1 === _this3.state.activeColumn) {
          return _react.default.createElement(TopHeaderCell, {
            "data-key": i - 1,
            key: i
          }, _react.default.createElement(_H2.default, null, _react.default.createElement(_FormattedMessage.default, {
            message: "upgrades.productCatalog.tableHeader." + headerKey
          })));
        }

        return null;
      }))));
    }
  }, {
    key: "renderTierSelector",
    value: function renderTierSelector(headerKeys) {
      var _this4 = this;

      return _react.default.createElement(TierSelector, null, headerKeys.slice(1).map(function (headerKey, i) {
        return _react.default.createElement("button", {
          onClick: (0, _partial.default)(_this4.handleTierSelect, i),
          key: i,
          className: _this4.state.activeColumn === i ? 'active' : ''
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.productCatalog.tableHeader." + headerKey
        }));
      }));
    }
  }, {
    key: "renderPhoneTierSelector",
    value: function renderPhoneTierSelector(headerKeys) {
      var _this5 = this;

      return _react.default.createElement(TierSelector, null, _react.default.createElement("input", {
        type: "checkbox",
        id: "tierToggle"
      }), _react.default.createElement(TierSelected, {
        htmlFor: "tierToggle"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.productCatalog.tableHeader." + headerKeys.slice(1)[this.state.activeColumn]
      })), _react.default.createElement(_UIIcon.default, {
        name: "downCarat",
        size: 12
      }), _react.default.createElement("ul", null, headerKeys.slice(1).map(function (headerKey, i) {
        return _react.default.createElement("li", {
          onClick: (0, _partial.default)(_this5.handleTierSelect, i),
          key: i
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.productCatalog.tableHeader." + headerKey
        }));
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hub = _this$props.hub,
          onCloseClick = _this$props.onCloseClick,
          merchandiseMap = _this$props.merchandiseMap;
      var highlightedFreeMerch = _HubMap.default[hub].highlightedFreeMerch ? [_HubMap.default[hub].highlightedFreeMerch] : [];
      var allEditions = [].concat(highlightedFreeMerch, (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch)).map(function (merch) {
        return merchandiseMap[merch].edition && merchandiseMap[merch].edition.toLowerCase();
      });
      var headerKeys = ['features'].concat((0, _toConsumableArray2.default)(allEditions));
      return _react.default.createElement(_UIModal.default, {
        use: "conversational",
        width: MODAL_WIDTH,
        style: {
          overflow: 'hidden'
        },
        "data-selenium-id": "product-catalog-" + hub
      }, _react.default.createElement(HeaderSection, null, _react.default.createElement(ModalHeader, null, _react.default.createElement(_UIImage.default, {
        className: "display-inline m-right-2 m-bottom-2",
        src: _ProductPageIcons.default[hub]
      }), _react.default.createElement(_H.default, {
        className: "display-inline"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricing-pages.hubs." + hub + ".name"
      })), _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: (0, _partial.default)(onCloseClick),
        "data-selenium-id": "product-catalog-close-" + hub
      }))), _react.default.createElement(_react.default.Fragment, null, this.state.width <= 500 ? this.renderPhoneTierSelector(headerKeys) : this.renderTierSelector(headerKeys), _react.default.createElement("div", null, this.state.width <= 800 ? this.renderMobileTableHeader(headerKeys) : this.renderTableHeader(headerKeys), _react.default.createElement(_UIScrollContainer.default, {
        maxHeight: "calc(100vh - " + (HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN) + "px)",
        scrollDirection: 'vertical'
      }, _react.default.createElement(Table, null, _react.default.createElement("tbody", null, this.state.width <= 800 ? this.renderMobileTableRows() : this.renderTableRows())), _react.default.createElement(_FooterMicrocopy.default, null)))));
    }
  }]);
  return ProductCatalogModal;
}(_react.default.Component);

ProductCatalogModal.propTypes = {
  hub: _propTypes.default.string.isRequired,
  onCloseClick: _propTypes.default.func.isRequired,
  merchandiseMap: _propTypes.default.object.isRequired
};
var _default = ProductCatalogModal;
exports.default = _default;
module.exports = exports.default;